module.exports = __webpack_public_path__ + "img/send-invites-mobile-fr.9b61a892.jpg";